'use strict';

export enum NotificationStyle {
  Default = 'Default',
  Error = 'Error',
  Info = 'Info',
  Success = 'Success',
  Warning = 'Warning',
}
